export function isAdminRoute(path: string): boolean {
  let decoded = path.split(/[?#]/, 1)[0];
  try { decoded = decodeURIComponent(decoded); } catch { return false; }
  return /^\/admin(?:\/|$)/i.test(decoded);
}
